module.exports = __webpack_public_path__ + "static/media/bg_log.81e6ce39.webp";